import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GET_PILL, GET_PILL_HISTORY } from "../querykeys";
import { request } from "../api";
import { BaseResponse } from "../types/baseRespones";
import { showAlert } from "src/components/containers/Alert";
import { useNavigate } from "react-router-dom";

/* 복약 기록 가져오기 */
export const useMedRegister = (date: string) => {
  return useQuery({
    queryKey: [GET_PILL, date],
    queryFn: async () => {
      const result = await request<BaseResponse<any[]>>({
        method: "GET",
        url: `/medication/schedule?date=${date}`,
      });
      return result.response || [];
    },
  });
};

/* 복약 기록 추가하기 */
export const useCreateMedication = () => {
  const queryClient = useQueryClient();
  const navi = useNavigate();

  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "POST",
        url: `/medication/schedule`,
        data: payLoad,
      });
    },
    onSuccess: async (res: any) => {
      if (res.success) {
        navi("/pill", { replace: true, state: { toast: res.message } });
      } else {
        await showAlert(res.message);
      }
      queryClient.invalidateQueries({ queryKey: [GET_PILL] });
    },
  });
};

/* 복약 기록 수정하기 */
export const useUpdateMedication = ({ oid }: any) => {
  const queryClient = useQueryClient();
  const navi = useNavigate();
  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "PUT",
        url: `/medication/schedule/${oid}`,
        data: payLoad,
      });
    },
    onSuccess: async (res: any) => {
      if (res.success) {
        navi("/pill", { replace: true, state: { toast: res.message } });
      } else {
        await showAlert(res.message);
      }
      queryClient.invalidateQueries({ queryKey: [GET_PILL] });
    },
  });
};

/* 복용 기록 가져오기 */
export const useHistoryRegister = (oidList: string[]) => {
  return useQuery({
    queryKey: [GET_PILL_HISTORY, oidList],
    queryFn: async () => {
      const result = await request<BaseResponse<any[]>>({
        method: "GET",
        url: `/medication/history`,
        data: { oid: oidList },
      });
      return result.response || [];
    },
  });
};

/* 복용 생성 api */
export const useCreateHistory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "POST",
        url: `/medication/history`,
        data: payLoad,
      });
    },
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries({ queryKey: [GET_PILL, GET_PILL_HISTORY] });
    },
  });
};

/* 복용 기록 수정 api */
export const useUpdateHistory = ({ oid }: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "PUT",
        url: `/medication/history/${oid}`,
        data: payLoad,
      });
    },
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries({ queryKey: [GET_PILL, GET_PILL_HISTORY] });
    },
  });
};

/* 약 삭제 api */
export const useDeleteMedication = ({ oid }: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request<BaseResponse>({
        method: "DELETE",
        url: `/medication/schedule/${oid}`,
      });
    },
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries({ queryKey: [GET_PILL, GET_PILL_HISTORY] });
    },
  });
};

/* 복용 기록 취소 api */
export const useDeleteHistory = ({ oid }: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return request<BaseResponse>({
        method: "DELETE",
        url: `/medication/history/${oid}`,
      });
    },
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries({ queryKey: [GET_PILL, GET_PILL_HISTORY] });
    },
  });
};
